module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"date":"Date","description":"Description","amount":"Amount","notFound":"No transactions found"},"et":{"date":"Date","description":"Description","amount":"Amount","notFound":"No transactions found"},"ru":{"date":"Date","description":"Description","amount":"Amount","notFound":"No transactions found"}}')
  delete Component.options._Ctor
}
